export const scrolling = props => {
    const { to, duration } = props;
    const from = window.pageYOffset;
    const start = performance.now();
    const timeK = duration / 100;
    const percentStepValue = (from - to) / 100;
    const draw = s => {
        window.scrollTo(0, s);
    };
    const step = () => {
        const now = performance.now();
        const timePassed = now - start;
        if (timePassed < duration) {
            draw(from - timePassed / timeK * percentStepValue);
            requestAnimationFrame(step);
        } else {
            draw(to);
        }
    };
    requestAnimationFrame(step);
};
